window.okeReviewsWidgetOnInit = function () {
    setupAggregateSection();

    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const config = {
            childList: true
        };
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach((n) => setupReviews(n));
            }
        };
        const observer = new MutationObserver(callback, config);
        observer.observe(reviewMain, config);

        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach((n) => setupReviews(n));
    }
};

function setupAggregateSection() {
    const warButton = document.querySelector('.js-okeReviews-writeReview:not(.is-okeReviews-hidden)');
    const aggregateSide = document.querySelector('.okeReviews-reviewsAggregate-side');
    // Move WaR Button inside Aggregate Side
    if (warButton && aggregateSide) {
        aggregateSide.insertAdjacentElement('beforeend', warButton);
    } 
}

function setupReviews(nodeElement) {
    const reviewDate = nodeElement.querySelector('.okeReviews-review-date');
  	const reviewReviewer = nodeElement.querySelector('.okeReviews-review-reviewer');
    // Move Date above Reviewer Name
    if (reviewDate && reviewReviewer) {
        reviewReviewer.insertAdjacentElement('beforebegin', reviewDate);
    }
  
    const reviewRating = nodeElement.querySelector('.okeReviews-review-starRating');
    const reviewHeadline = nodeElement.querySelector('.okeReviews-review-main-heading');
    // Move Review Rating besides Reviewer Headline
    if (reviewRating && reviewHeadline) {
        reviewRating.insertAdjacentElement('afterend', reviewHeadline);
    }
  
    const reviewRecommendation = nodeElement.querySelector('.okeReviews-review-recommendation');
    const reviewMainControls = nodeElement.querySelector('.okeReviews-review-main-content-controls');
    // Move Product Recommendation Below Review
    if (reviewRecommendation && reviewMainControls) {
        reviewMainControls.insertAdjacentElement('afterend', reviewRecommendation);
    }
  
    const reviewAttributes = nodeElement.querySelector('.okeReviews-review-reviewer-attributes');
    const reviewAttributeRatings = nodeElement.querySelector('.js-okeReviews-reviewMain');
    // Move Reviewer Attributes
    if (reviewAttributeRatings && reviewAttributes) {
        reviewAttributeRatings.insertAdjacentElement('afterend', reviewAttributes);
    }
  
    // Make More Details Button
  	if(reviewAttributes) {
        const seeMoreButton = nodeElement.querySelector('.js-okeReviews-readMore');
        const readLess = document.createElement('BUTTON');
        if (seeMoreButton) {
            seeMoreButton.innerText = "More Details ∨";
            seeMoreButton.addEventListener('click', function() {
                seeMoreButton.style.display = "none";
                readLess.style.display = "block";
                reviewAttributes.classList.add("expanded");  
            });
        }

        // Create Less Details Button
        const reviewMainControls = nodeElement.querySelector('.okeReviews-review-main-content-controls');
        readLess.classList.add("okeReviews-review-main-readLess-button");
        readLess.innerText = "Less Details ∧";
        // Move read less button before end of attribute list
        if(readLess) {
            reviewMainControls.insertAdjacentElement('beforeend', readLess);
            readLess.addEventListener('click', function() {
                seeMoreButton.style.display = "block";
                readLess.style.display = "none";
                reviewAttributes.classList.remove("expanded");   
            });
        }
    }
  else {
      const reviewMainControls = nodeElement.querySelector('.okeReviews-review-main-content-controls');
        reviewMainControls.style.display = "none";
      }
}